import * as React from 'react';
import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { IEvent } from '../../custom/classes/event';
import { connect } from 'react-redux';

import ListDayView from 'list-day.view';

interface IListDayExternalProps {
    day: IDay<IEvent>;
}

export type ListDayProps = IListDayExternalProps;

export class ListDayBase extends React.Component<ListDayProps, any> {
    render() {
        return (
            <ListDayView {...this.props} />
        )
    }
}

export default ListDayBase;